var _path, _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgResultHistory(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9871 5.43203H19.0751V4.97123C19.0751 3.55043 17.9231 2.39844 16.5023 2.39844H7.49749C6.81514 2.39844 6.16074 2.6695 5.67825 3.15199C5.19576 3.63448 4.9247 4.28888 4.9247 4.97123V5.43203H4.0127C3.1199 5.43203 2.3999 6.15203 2.3999 7.04003V9.19522C2.3999 11.9216 4.1231 14.24 6.53749 15.1328C7.53109 16.304 8.90869 17.1392 10.4831 17.432V18.5648H7.36309C6.96081 18.5648 6.57501 18.7246 6.29055 19.0091C6.0061 19.2935 5.84629 19.6793 5.84629 20.0816C5.84629 20.4839 6.0061 20.8697 6.29055 21.1541C6.57501 21.4386 6.96081 21.5984 7.36309 21.5984H16.6367C17.4719 21.5984 18.1535 20.9168 18.1535 20.0816C18.1535 19.2464 17.4767 18.5696 16.6367 18.5648H13.5167V17.432C15.0863 17.1392 16.4687 16.304 17.4623 15.1328C19.8767 14.24 21.5999 11.9216 21.5999 9.19522V7.04003C21.5999 6.15203 20.8799 5.43203 19.9871 5.43203Z",
    fill: "url(#paint0_linear_6659_24899)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 10.6287,
    y: 6.5127,
    width: 2.74285,
    height: 6.85713,
    rx: 1.37143,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6659_24899",
    x1: 11.9999,
    y1: 2.39844,
    x2: 11.9999,
    y2: 21.5984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D68D00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A86F00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResultHistory);
export default __webpack_public_path__ + "static/media/result-history.f510800eaef37600c9c4d1a03e43c0de.svg";
export { ForwardRef as ReactComponent };